import { Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/categories", label: "漫画分类" },
  { to: "/about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100 text-foreground-700">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-line text-lg" aria-hidden="true" />
            </span>
            <span className="font-heading text-xl text-foreground-950">
              漫悦<span className="text-primary-600">漫画</span>网
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed">
            专业的在线漫画阅读平台，支持翻页模式、横屏阅读、夜间模式与缓存下载，为你打造舒适流畅的追漫体验。
          </p>
        </div>

        <div>
          <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
          <ul className="mt-4 space-y-3 text-sm">
            {quickLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="transition-colors hover:text-primary-600">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-base text-foreground-950">热门分类</h3>
          <ul className="mt-4 grid grid-cols-2 gap-3 text-sm">
            {categories.slice(1).map((c) => (
              <li key={c.id}>
                <Link to={`/categories?cat=${c.id}`} className="transition-colors hover:text-primary-600">
                  {c.name}漫画
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-base text-foreground-950">联系我们</h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500" aria-hidden="true" />
              service@manyue-manga.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-primary-500" aria-hidden="true" />
              400-820-2026
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-primary-500" aria-hidden="true" />
              上海市静安区南京西路漫画创意园区
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 漫悦漫画网 版权所有 · 漫画内容版权归原作者所有，仅供交流学习使用。</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-primary-600">隐私政策</Link>
            <Link to="/about" className="hover:text-primary-600">服务条款</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}